/** @format */

import React, { useEffect } from "react";
import { getVendorSettings } from "../../../services/helper";
import ItemAddonView from "../ItemAddonView";

const LabelPrint = () => {
  const latestOrder = JSON.parse(localStorage.getItem("latestOrder"));
  const vendor_store_name = getVendorSettings("name");
  const vendor_address = getVendorSettings("vendor_contact_address");
  const vendor_logo = `${window.location.origin}/assets/images/logo/logo.png`;

  useEffect(() => {
    if (latestOrder) {
      setTimeout(() => window.print(), 500);
    }
  }, [latestOrder]);

  if (!latestOrder || !Array.isArray(latestOrder.items)) {
    return <p>No items found for label printing</p>;
  }

  const allLabels = latestOrder.items.flatMap((item) => {
    const quantity = parseInt(item.quantity) || 1;
    const addons =
      typeof item.addons === "string" ? JSON.parse(item.addons) : item.addons;

    return Array.from({ length: quantity }, () => ({
      name: item.name,
      addons,
    }));
  });

  return (
    <div style={{ padding: "10px" }}>
      {allLabels.map((label, index) => (
        <div
          key={index}
          style={{
            width: "68mm",
            border: "1px dashed #ccc",
            margin: "10px auto",
            padding: "10px",
            fontSize: "12px",
            fontFamily: "monospace",
            pageBreakAfter: "always",
          }}
        >
          {/* Logo */}
          <div style={{ textAlign: "center", marginBottom: "5px" }}>
            <img
              src={vendor_logo}
              alt="store-logo"
              style={{ maxHeight: "30px" }}
            />
          </div>

          {/* Store Name & Address */}
          <div style={{ textAlign: "center", marginBottom: "5px" }}>
            <strong>{vendor_store_name}</strong>
            <br />
            <small>{vendor_address}</small>
          </div>

          {/* Item Name */}
          <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
            {label.name}
          </div>

          {/* Addons (if any) */}
          {label.addons && Object.keys(label.addons).length > 0 && (
            <div
              style={{
                fontSize: "11px",
                color: "#666",
                marginTop: "5px",
              }}
            >
              <ItemAddonView addons={label.addons} hide_price={true} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LabelPrint;
